import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import type { SwiftIdVerifySubmissionCollection } from './swift-id-verify-submission.types';

export function swiftIdVerifySubmissionBackend(): Backend<SwiftIdVerifySubmissionCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: undefined,
    push: (authUid, submission) => ({
      asFormData: false,
      endpoint: 'swift-id/verifyApplication.php',
      isGaf: true,
      method: 'POST',
      payload: {
        pepCheckReferenceIds: submission.pepCheckReferenceIds,
        applicantIds: submission.applicantIds,
        applicationId: submission.applicationId,
        status: submission.status,
      },
    }),
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
